/**
 * Mobile Menu Countdown - Moon Moon Agency
 * Handles the special offer countdown timer in the mobile menu
 */

/*********************************************************************************************
 * ⏱ COUNTDOWN MANAGER
 */
const MobileMenuCountdownManager = {
    config: {
        selectors: {
            wrapper: '[data-special-offer]',
            countdown: '[data-countdown-wrapper]',
            days: '[data-countdown-days]',
            hours: '[data-countdown-hours]',
            minutes: '[data-countdown-minutes]',
        },
    },

    init() {
        const wrapper = window.getElement(this.config.selectors.wrapper);
        if (!wrapper) return;

        const endAttr = wrapper.dataset.end;
        if (!endAttr) {
            window.log('warn', '⏱ [COUNTDOWN]', 'Missing end date, hiding countdown');
            this._hideCountdown(wrapper);
            return;
        }

        const endDate = new Date(endAttr);
        if (isNaN(endDate.getTime())) {
            window.log('warn', '⏱ [COUNTDOWN]', 'Invalid end date', { endAttr });
            this._hideCountdown(wrapper);
            return;
        }

        this._tick(wrapper, endDate);
        this._interval = setInterval(() => this._tick(wrapper, endDate), 60000);

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') this._tick(wrapper, endDate);
        });

        window.log('info', '⏱ [COUNTDOWN]', 'Initialized', { endDate });
    },

    _hideCountdown(wrapper) {
        const countdown = wrapper.querySelector(this.config.selectors.countdown);
        if (countdown) countdown.hidden = true;
    },

    _tick(wrapper, endDate) {
        const now = new Date();
        const diff = endDate - now;

        if (diff <= 0) {
            clearInterval(this._interval);
            wrapper.hidden = true;
            return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        const daysEl = wrapper.querySelector(this.config.selectors.days);
        const hoursEl = wrapper.querySelector(this.config.selectors.hours);
        const minutesEl = wrapper.querySelector(this.config.selectors.minutes);

        if (daysEl) daysEl.textContent = days;
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    },
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => MobileMenuCountdownManager.init());
} else {
    MobileMenuCountdownManager.init();
}
